import PropTypes from 'prop-types';

import { Box } from '@hivebrite/design-system/Box';
import { Link } from '@hivebrite/design-system/Link';

import dayjs from 'hb-react/shared/utils/dayjs/dayjs';
import { completeName } from 'helpers/name';

const CommentedLabel = ({ comment: { user, created_at: createdAt } }) => (
  <Box display="block">
    <Box as="span" display="inline" font="metadata-semibold-asphalt">
      <Link styledOnlyOnHover to={Routes.user_path(user.id)}>
        {completeName(user)}
      </Link>
      &nbsp;
    </Box>
    <Box as="span" display="inline" font="metadata-regular-asphalt">
      {s__('LiveFeed|commented %{when}').i__({
        when: dayjs(createdAt).fromNow(),
      })}
    </Box>
  </Box>
);

CommentedLabel.propTypes = {
  comment: PropTypes.shape({
    user: PropTypes.object.isRequired,
    created_at: PropTypes.string.isRequired,
  }).isRequired,
};

export default CommentedLabel;
